import { Box, Grid, Typography } from '@mui/material';
import React from 'react'
import Images from '../../../utils/Images';

const FranchiseFormat = () => {
    return (
        <section className="franchiseFormats">

            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <h1 className="franchiseFormatTitle">Flexible Formats <br /> for Every Location</h1>
                <p className="franchiseFormatPara">Whether it's a bustling mall or a high-footfall airport, Xpanse adapts to fit. Our outlet models are designed to suit space, budget and customer flow.</p>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <h1 className="franchiseFormatTitle">Flexible Formats for Every Location</h1>
                <p className="franchiseFormatPara">Whether it's a bustling mall or a high-footfall airport, Xpanse adapts to fit.<br />Our outlet models are designed to suit space, budget and customer flow.</p>
            </Box>

            <Box sx={{ display: { xs: 'none', md: 'flex' } }} justifyContent={'center'}>
                <Grid container md={8} display={'flex'} justifyContent={'center'}>
                    <Grid item md={6} className="franchiseFormatDetails">
                        <Typography className="franchiseFormatName" fontWeight={'800'}>Xpanse To-Go</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}><i>Compact, Fast, Perfect for high-traffic zones.</i></Typography>
                        <Typography className="franchiseFormatPoint franchiseFormatSize" fontWeight={'900'}><b>150-300 sq ft</b></Typography>

                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Ideal for corporate parks, transit points and kiosks</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Grab-and-go format with lean operations</Typography>
                    </Grid>
                    <Grid item md={6}>
                        <img alt={Images.toGoCafe} style={{ height: '100%', width: '100%' }} src={Images.toGoCafe} />
                    </Grid>
                    <Grid item md={6}>
                        <img alt={Images.qwikCafe} style={{ height: '100%', width: '100%' }} src={Images.qwikCafe} />
                    </Grid>
                    <Grid item md={6} className="franchiseFormatDetails">
                        <Typography className="franchiseFormatName" fontWeight={'800'}>Xpanse Qwik</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}><i>Sleek, Efficient, Built for speed & scale.</i></Typography>
                        <Typography className="franchiseFormatPoint franchiseFormatSize" fontWeight={'900'}><b>300-700 sq ft</b></Typography>

                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Ideal for corporate parks, transit points and kiosks</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Grab-and-go format with lean operations</Typography>
                    </Grid>
                    <Grid item md={6} className="franchiseFormatDetails">
                        <Typography className="franchiseFormatName" fontWeight={'800'}>Xpanse Flagship</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}><i>Spacious. Complete. The full Xpanse experience.</i></Typography>
                        <Typography className="franchiseFormatPoint franchiseFormatSize" fontWeight={'900'}><b>1000+ sq ft</b></Typography>

                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Ideal for premium commercial zones and high-footfall areas</Typography>
                        <Typography className="franchiseFormatPoint" fontWeight={'500'}>Full menu, plush seating, and immersive brand experience</Typography>
                    </Grid>
                    <Grid item md={6}>
                        <img alt={Images.flagshipCafe} style={{ height: '100%', width: '100%' }} src={Images.flagshipCafe} />
                    </Grid>
                </Grid>
            </Box>

            <Box  sx={{ display: { xs: 'flex', md: 'none' } }} display="flex" justifyContent="center">
                <Grid container md={8} spacing={4} justifyContent="center">
                    {[
                        {
                            title: 'Xpanse To-Go',
                            subtitle: 'Compact, Fast. Perfect for high-traffic zones.',
                            size: '150–300 sq ft',
                            points: [
                                'Ideal for corporate parks, transit points and kiosks',
                                'Grab-and-go format with lean operations',
                            ],
                            image: Images.toGoCafe,
                        },
                        {
                            title: 'Xpanse Qwik',
                            subtitle: 'Sleek, Efficient, Built for speed & scale.',
                            size: '300–700 sq ft',
                            points: [
                                'Ideal for corporate parks, transit points and kiosks',
                                'Grab-and-go format with lean operations',
                            ],
                            image: Images.qwikCafe,
                        },
                        {
                            title: 'Xpanse Flagship',
                            subtitle: 'Spacious. Complete. The full Xpanse experience.',
                            size: '1000+ sq ft',
                            points: [
                                'Ideal for premium commercial zones and high-footfall areas',
                                'Full menu, plush seating, and immersive brand experience',
                            ],
                            image: Images.flagshipCafe,
                        }
                    ].map((item, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    backgroundColor: { xs: '#fff', md: 'transparent' },
                                    overflow: 'hidden',
                                    height: '100%',
                                }}
                            >
                                <Box sx={{ width: { xs: '100%', md: '50%' } }}>
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </Box>
                                <Box
                                    className="franchiseFormatDetails"
                                    sx={{
                                        width: { xs: '100%', md: '50%' },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography className="franchiseFormatName" fontWeight={800}>{item.title}</Typography>
                                    <Typography className="franchiseFormatPoint" fontWeight={500} fontStyle="italic">
                                        {item.subtitle}
                                    </Typography>
                                    <Typography className="franchiseFormatPoint franchiseFormatSize" fontWeight={900}>
                                        <b>{item.size}</b>
                                    </Typography>
                                    {item.points.map((pt, idx) => (
                                        <Typography className="franchiseFormatPoint" fontWeight={500} key={idx}>{pt}</Typography>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>


        </section>
    )
}

export default FranchiseFormat;
